import {
    onAuthStateChanged as firebaseOnAuthStateChanged,
    signOut as firebaseSignOut,
    User as FirebaseUser,
    getAuth,
    GoogleAuthProvider,
    signInWithPopup,
} from 'firebase/auth';
import { User } from '../../types/auth';
import { IAuthService } from '../interfaces/IAuthService';

export class FirebaseAuthService implements IAuthService {
  private auth;
  private provider;

  constructor() {
    this.auth = getAuth();
    this.provider = new GoogleAuthProvider();
    
    // Optional: Add custom scopes
    // this.provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
  }

  async signInWithGoogle(): Promise<User> {
    try {
      const result = await signInWithPopup(this.auth, this.provider);
      return this.mapFirebaseUser(result.user);
    } catch (error) {
      console.error('Google sign-in error:', error);
      throw error;
    }
  }

  async signOut(): Promise<void> {
    try {
      await firebaseSignOut(this.auth);
    } catch (error) {
      console.error('Sign-out error:', error);
      throw error;
    }
  }

  getCurrentUser(): User | null {
    const user = this.auth.currentUser;
    return user ? this.mapFirebaseUser(user) : null;
  }

  onAuthStateChanged(callback: (user: User | null) => void): () => void {
    return firebaseOnAuthStateChanged(this.auth, (firebaseUser) => {
      const user = firebaseUser ? this.mapFirebaseUser(firebaseUser) : null;
      callback(user);
    });
  }

  isAuthenticated(): boolean {
    return this.auth.currentUser !== null;
  }

  /**
   * Map Firebase user to our User interface
   */
  private mapFirebaseUser(firebaseUser: FirebaseUser): User {
    return {
      uid: firebaseUser.uid,
      email: firebaseUser.email,
      displayName: firebaseUser.displayName,
      photoURL: firebaseUser.photoURL,
    };
  }
}

